// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.gray {
  color: #292727;
}

.heading, .day-heading, .snooze-popup-wrapper .open-date-picker .react-datepicker .react-datepicker__current-month, .current-day-heading {
  font-weight: 200;
  text-transform: uppercase;
  color: #999;
}

.day-heading, .snooze-popup-wrapper .open-date-picker .react-datepicker .react-datepicker__current-month, .current-day-heading {
  color: #555;
  font-size: 1.2rem;
  padding-bottom: 0.5rem;
}

.current-day-heading {
  font-weight: bold;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
}

.snooze-popup-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 6000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.snooze-popup-wrapper .snooze-popup {
  background: white;
  padding: 1rem 1rem 0;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  color: #696969;
  box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);
}
.snooze-popup-wrapper .snooze-popup__heading {
  margin: 0 0 1rem;
  font-size: 2rem;
  width: 100%;
}
.snooze-popup-wrapper .snooze-popup__body {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  align-content: center;
  margin: 0 0 0rem;
  width: 18rem;
}
.snooze-popup-wrapper .snooze-popup__body .open-date-picker {
  margin: auto;
}
.snooze-popup-wrapper .snooze-popup__body .react-select {
  margin: 0 1rem;
  align-self: stretch;
}
.snooze-popup-wrapper .snooze-popup__body .spacer {
  flex: 1 1 1%;
}
.snooze-popup-wrapper .snooze-popup__buttons {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.snooze-popup-wrapper .snooze-popup__buttons .btn-default {
  min-width: 8rem;
}
.snooze-popup-wrapper .snooze-popup label,
.snooze-popup-wrapper .snooze-popup .label {
  font-weight: 100;
  -webkit-font-smoothing: subpixel-antialiased;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker {
  border: 0;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__current-month {
  word-spacing: 4rem;
  margin-bottom: 1rem;
  font-weight: normal;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__current-month:first-line {
  font-size: 1.8rem !important;
  font-weight: normal;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__navigation--previous {
  color: #292727;
  left: 1rem;
  top: 3rem;
  display: inline-block;
  font: normal normal normal 1.4rem/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  overflow: visible;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__navigation--previous:after {
  content: "\\f053";
  font-size: 1.2rem;
  font-weight: normal;
  color: #c0c0c0;
  text-indent: 0;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__navigation--next {
  color: #292727;
  display: inline-block;
  font: normal normal normal 1.4rem/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  right: 1.2rem;
  top: 3rem;
  overflow: visible;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__navigation--next:after {
  content: "\\f054";
  font-size: 1.2rem;
  font-weight: normal;
  color: #c0c0c0;
  text-indent: 0;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__month-container {
  width: 100%;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__month-container .react-datepicker__header {
  text-align: center;
  margin: auto;
  font-family: Raleway !important;
  padding-top: 0;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker .react-datepicker__current-month {
  font-size: 1.6rem;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__day {
  padding: 0;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__day--highlighted:after {
  background-color: transparent;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__day--selected:after {
  background-color: #dabc64;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__day--today:before {
  width: 1.7rem;
  height: 1.7rem;
}
.snooze-popup-wrapper .open-date-picker .react-datepicker__day:hover:before {
  width: 1.7rem;
  height: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/ChecklistsDisplay/SnoozePopup.scss","webpack://./src/Styles/Material.scss","webpack://./src/Styles/Base.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gBAAA;EACA,eAAA;ADKF;;ADuBA;EACE,cArCU;ACiBZ;;AEhBA;EACE,gBCoBkB;EDnBlB,yBAAA;EACA,WHsCa;ACnBf;;AEhBA;EAEE,WHkCgB;EGjChB,iBAAA;EACA,sBAAA;AFkBF;;AEfA;EAEE,iBAAA;AFiBF;;AEdA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,SAAA;AFiBF;;AA3CA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aG4BkB;EH3BlB,aAAA;EACA,mBAAA;EACA,uBAAA;AA6CF;AA3CE;EACE,iBAAA;EACA,oBAAA;EAEA,aAAA;EACA,iBAAA;EACA,oBAAA;EAEA,cDtBY;EC0BZ,2DAAA;AA0CJ;AAxCI;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AA0CN;AAvCI;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AAyCN;AAvCM;EACE,YAAA;AAyCR;AAtCM;EACE,cAAA;EACA,mBAAA;AAwCR;AArCM;EACE,YAAA;AAuCR;AAnCI;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;AAqCN;AAnCM;EACE,eAAA;AAqCR;AAjCI;;EAEE,gBAAA;EACA,4CAAA;AAmCN;AA/BE;EACE,SAAA;AAiCJ;AAhCI;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAkCN;AAjCM;EACE,4BAAA;EACA,mBAAA;AAmCR;AA/BI;EACE,cDvFM;ECwFN,UAAA;EACA,SAAA;EACA,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAiCN;AAhCM;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cD/FM;ECgGN,cAAA;AAkCR;AA9BI;EACE,cDzGM;EC0GN,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AAgCN;AA/BM;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cDjHM;ECkHN,cAAA;AAiCR;AA7BI;EACE,WAAA;AA+BN;AA9BM;EACE,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;AAgCR;AA5BI;EAEE,iBAAA;AA6BN;AA1BI;EACE,UAAA;AA4BN;AAzBI;EACE,6BAAA;AA2BN;AAxBI;EACE,yBDlIC;AC4JP;AAvBI;EACE,aAAA;EACA,cAAA;AAyBN;AAtBI;EACE,aAAA;EACA,cAAA;AAwBN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n@import '~/Styles/Material';\n@import '~/Styles/Base';\n\n.snooze-popup-wrapper {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  // background-color: rgba(0, 0, 0, 0.5);\n  z-index: $modalConfirmLayer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .snooze-popup {\n    background: white;\n    padding: 1rem 1rem 0;\n\n    display: flex;\n    flex-flow: column;\n    align-items: stretch;\n\n    color: $darkTextColor;\n\n    -webkit-box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n    -moz-box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n    box-shadow: 0.2rem 0.3rem 0.5rem 0.1rem rgba(0, 0, 0, 0.19);\n\n    &__heading {\n      margin: 0 0 1rem;\n      font-size: 2rem;\n      width: 100%;\n    }\n\n    &__body {\n      display: flex;\n      flex-flow: column;\n      align-items: flex-start;\n      align-content: center;\n      margin: 0 0 0rem;\n      width: 18rem;\n\n      .open-date-picker {\n        margin: auto;\n      }\n\n      .react-select {\n        margin: 0 1rem;\n        align-self: stretch;\n      }\n\n      .spacer {\n        flex: 1 1 1%;\n      }\n    }\n\n    &__buttons {\n      text-align: right;\n      display: flex;\n      justify-content: flex-end;\n\n      .btn-default {\n        min-width: 8rem;\n      }\n    }\n\n    label,\n    .label {\n      font-weight: 100;\n      -webkit-font-smoothing: subpixel-antialiased;\n    }\n  }\n\n  .open-date-picker .react-datepicker {\n    border: 0;\n    &__current-month {\n      word-spacing: 4rem;\n      margin-bottom: 1rem;\n      font-weight: normal;\n      &:first-line {\n        font-size: 1.8rem !important;\n        font-weight: normal;\n      }\n    }\n\n    &__navigation--previous {\n      color: $textColor;\n      left: 1rem;\n      top: 3rem;\n      display: inline-block;\n      font: normal normal normal 1.4rem/1 FontAwesome;\n      font-size: inherit;\n      text-rendering: auto;\n      overflow: visible;\n      &:after {\n        content: '\\F053';\n        font-size: 1.2rem;\n        font-weight: normal;\n        color: $borderColor;\n        text-indent: 0;\n      }\n    }\n\n    &__navigation--next {\n      color: $textColor;\n      display: inline-block;\n      font: normal normal normal 1.4rem/1 FontAwesome;\n      font-size: inherit;\n      text-rendering: auto;\n      right: 1.2rem;\n      top: 3rem;\n      overflow: visible;\n      &:after {\n        content: '\\F054';\n        font-size: 1.2rem;\n        font-weight: normal;\n        color: $borderColor;\n        text-indent: 0;\n      }\n    }\n\n    &__month-container {\n      width: 100%;\n      .react-datepicker__header {\n        text-align: center;\n        margin: auto;\n        font-family: Raleway !important;\n        padding-top: 0;\n      }\n    }\n\n    .react-datepicker__current-month {\n      @extend .day-heading;\n      font-size: 1.6rem;\n    }\n\n    &__day {\n      padding: 0;\n    }\n\n    &__day--highlighted:after {\n      background-color: transparent;\n    }\n\n    &__day--selected:after {\n      background-color: $gold;\n    }\n\n    &__day--today:before {\n      width: 1.7rem;\n      height: 1.7rem;\n    }\n\n    &__day:hover:before {\n      width: 1.7rem;\n      height: 1.7rem;\n    }\n  }\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.heading {\n  font-weight: $headingFontWeight;\n  text-transform: uppercase;\n  color: $headingColor;\n}\n\n.day-heading {\n  @extend .heading;\n  color: $dayHeadingColor;\n  font-size: 1.2rem;\n  padding-bottom: 0.5rem;\n}\n\n.current-day-heading {\n  @extend .day-heading;\n  font-weight: bold;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  border: 0;\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
